<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Location from "@/router/views/property/settings-template/location";
import Warehouse from "@/router/views/property/settings-template/warehouse";
import ItemCategory from "@/router/views/property/settings-template/item-category";
import FundCluster from "@/router/views/property/settings-template/fund-cluster";

export default {
  page: {
    title: "Supply & Assets Settings",
  },
  components: {
    Layout,
    PageHeader,
    Location,
    Warehouse,
    ItemCategory,
    FundCluster,
  },
  data() {
    return {
      title: "Supply & Assets Settings",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Supply & Assets Settings",
          active: true,
        },
      ],
      selectedCampus: null,
      tabIndex: 0,
    };
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
  },
  methods: {
    changeCampus(data) {
      this.selectedCampus = data.id;
    },
    getLocation() {
      this.$store.dispatch("data/mutateGlobalStop", true);
      this.$refs.location.getData();
    },
    getWarehouse() {
      this.$store.dispatch("data/mutateGlobalStop", true);
      this.$refs.warehouse.getData();
    },
    getItemCategory() {
      this.$store.dispatch("data/mutateGlobalStop", true);
      this.$refs.itemCategory.getItemCategoryGroup();
      this.$refs.itemCategory.getAccounts();
    },
    getFundCluster() {
      this.$store.dispatch("data/mutateGlobalStop", true);
      this.$refs.fundCluster.getData();
    },
  },
};
</script>
<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <b-tabs
      pills
      vertical
      v-model="tabIndex"
      nav-class="p-0"
      nav-wrapper-class="col-sm-2"
      content-class="pt-0 px-2 text-muted col-sm-10"
    >
      <b-tab title-item-class="mb-2" @click="getLocation">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">Location</span>
        </template>
        <location
          :key="selectedCampus"
          :selectedCampus="selectedCampus"
          ref="location"
        ></location>
      </b-tab>
      <b-tab title-item-class="mb-2" @click="getWarehouse">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">Warehouse</span>
        </template>
        <warehouse
          :key="selectedCampus"
          :selectedCampus="selectedCampus"
          ref="warehouse"
        ></warehouse>
      </b-tab>
      <b-tab title-item-class="mb-2" @click="getItemCategory">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">Item Category</span>
        </template>
        <item-category ref="itemCategory"></item-category>
      </b-tab>
      <b-tab title-item-class="mb-2" @click="getFundCluster">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">Fund Cluster</span>
        </template>
        <fund-cluster ref="fundCluster"></fund-cluster>
      </b-tab>
    </b-tabs>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}
</style>